// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__1Rep4","Search_input":"Search_Search_input__3Ro9h","Search_btn":"Search_Search_btn__2Votx"};